import { render, staticRenderFns } from "./ProveedoresComponent.vue?vue&type=template&id=697de5c5&"
import script from "./ProveedoresComponent.vue?vue&type=script&lang=js&"
export * from "./ProveedoresComponent.vue?vue&type=script&lang=js&"
import style0 from "./ProveedoresComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports